// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating ContactUs Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing ContactUs Worker')

  // $FlowFixMe
  const ContactUsWorker = require('worker-loader?name=[hash].contact-us.wrkr.js!./worker.js')
  worker = new ContactUsWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
